{
  "zh-TW": {
    "home": {
      "landing": {
        "title": "宇宙中的每一艘艦船，你的整支艦隊盡在一處。",
        "lede": "查詢任何艦船及其目前遊戲內的數據和配裝。",
        "signUp": "建立免費帳號",
        "browseShips": "瀏覽所有艦船",
        "scrollDown": "向下捲動",
        "searchTry": "試試",
        "featuredShip": "精選艦船",
        "searchResults": "搜尋結果",
        "searchNoResults": "沒有與「%{query}」相符的結果",
        "searchNoResultsHint": "試試艦船、組件、任務或地點。",
        "searchShowMore": "顯示更多",
        "searching": "搜尋中…",
        "searchFailed": "搜尋失敗，請再試一次。",
        "searchInCatalogue": "在目錄中搜尋",
        "searchScopes": {
          "mine": "我的物品",
          "fleet": "艦隊"
        },
        "searchKeys": {
          "add": "新增",
          "scope": "切換",
          "move": "移動",
          "open": "開啟",
          "close": "關閉"
        },
        "stats": {
          "ships": "艦船與載具",
          "vehicles": "機庫中的艦船",
          "fleets": "艦隊"
        },
        "features": {
          "title": "你可以在這裡做什麼",
          "subline": "所有飛行員免費使用，一切從你的機庫開始。",
          "withAccount": "免費註冊即可使用",
          "openToEveryone": "所有人可用",
          "hangar": {
            "label": "機庫",
            "hint": "你的 Pledge，自動同步",
            "title": "機庫",
            "action": "查看範例機庫",
            "items": {
              "sync": {
                "title": "RSI 機庫同步",
                "text": "從你的 RSI 帳號匯入所有 Pledge，包括回購項目。"
              },
              "paints": {
                "title": "塗裝與升級",
                "text": "記錄每艘船對應的塗裝和 CCU。"
              },
              "loadouts": {
                "title": "配裝",
                "text": "儲存你每艘船的配裝方案。"
              },
              "fleetchart": {
                "title": "艦隊圖",
                "text": "整個機庫並排展示，依真實比例。"
              },
              "log": {
                "title": "艦長日誌",
                "text": "為你擁有的每艘船記錄筆記和歷史。"
              },
              "share": {
                "title": "願望清單與公開連結",
                "text": "分享整個機庫，或只分享你想要的船。"
              }
            }
          },
          "fleets": {
            "label": "艦隊",
            "hint": "管理你的組織",
            "title": "艦隊",
            "action": "了解艦隊功能",
            "items": {
              "members": {
                "title": "成員與角色",
                "text": "邀請你的組織成員，劃分階級並決定誰能做什麼。"
              },
              "squadrons": {
                "title": "中隊",
                "text": "艦隊內的編隊，各有自己的成員和 Discord 角色。"
              },
              "maps": {
                "title": "世界地圖與星圖",
                "text": "你的成員住在哪裡，又在哪裡飛行。"
              },
              "ships": {
                "title": "艦隊的艦船",
                "text": "彙整所有成員的機庫，並附依比例的艦隊圖。"
              },
              "allies": {
                "title": "盟友與目錄",
                "text": "與盟友組織建立聯繫，讓新飛行員找到你。"
              },
              "discord": {
                "title": "Discord",
                "text": "角色和公告與你的伺服器同步。"
              }
            }
          },
          "ships": {
            "label": "艦船與數據",
            "hint": "來自遊戲檔案",
            "title": "艦船與數據",
            "action": "瀏覽艦船",
            "items": {
              "ships": {
                "title": "艦船與載具",
                "text": "數據、掛點以及每艘船出廠自帶的組件。"
              },
              "viewer": {
                "title": "3D 檢視器",
                "text": "在瀏覽器中旋轉檢視每艘船。"
              },
              "patches": {
                "title": "版本變化",
                "text": "每個新版本改了什麼，改了多少。"
              },
              "components": {
                "title": "組件與裝備",
                "text": "武器、護盾、引擎和 FPS 裝備，以及購買地點。"
              },
              "locations": {
                "title": "地點與商店",
                "text": "行星、衛星和太空站，以及每間商店販售的商品。"
              },
              "crafting": {
                "title": "製作與任務",
                "text": "每張藍圖及其材料，以及報酬豐厚的任務。"
              }
            }
          },
          "tools": {
            "label": "工具",
            "hint": "規劃行程",
            "title": "工具",
            "action": "開啟工具",
            "items": {
              "compare": {
                "title": "艦船比較",
                "text": "艦船並排比較，從貨艙格到量子燃料。"
              },
              "cargo": {
                "title": "貨艙格",
                "text": "逐箱檢視每個貨艙，知道能裝下什麼。"
              },
              "trade": {
                "title": "貿易路線",
                "text": "目前商品價格以及終端之間的最佳路線。"
              },
              "travel": {
                "title": "航行時間",
                "text": "一次量子躍遷需要多久，按引擎逐一計算。"
              },
              "tours": {
                "title": "行程",
                "text": "和朋友一起規劃行程並分配收益。"
              },
              "stats": {
                "title": "統計",
                "text": "艦船目錄如何隨版本成長。"
              }
            }
          },
          "developers": {
            "label": "開發者",
            "hint": "API、OAuth、嵌入",
            "title": "開發者",
            "action": "閱讀 API 文件",
            "codeComment": "每艘船，以 JSON 形式",
            "signIn": "使用 Fleetyards 登入",
            "items": {
              "api": {
                "title": "公開 API",
                "text": "艦船、組件、地點等，使用 OpenAPI 撰寫文件。"
              },
              "oauth": {
                "title": "使用 Fleetyards 登入",
                "text": "為你自己的應用程式提供 OAuth 和 OpenID Connect。"
              },
              "embed": {
                "title": "嵌入小工具",
                "text": "在你自己的網站上展示艦船、機庫或艦隊。"
              },
              "discord": {
                "title": "Discord 機器人",
                "text": "透過斜線指令查詢艦船、借用船、物品、機庫和地點。"
              },
              "app": {
                "title": "可安裝應用程式",
                "text": "把 Fleetyards 加到手機主畫面。"
              },
              "media": {
                "title": "艦船媒體",
                "text": "商店圖片、角度渲染圖和影片，可直接連結。"
              }
            }
          }
        },
        "patch": {
          "title": "本次版本",
          "subline": "直接來自遊戲檔案，逐個構建比較。",
          "version": "Alpha %{version}",
          "comparedWith": "比較 %{version}",
          "counts": {
            "newShips": "新艦船",
            "changedShips": "重新平衡",
            "newComponents": "新組件",
            "newEquipment": "新 FPS 物品"
          },
          "newThisPatch": "本次版本新增",
          "newIn": "%{version} 新增",
          "biggestChange": "最大變化",
          "kinds": {
            "models": "艦船",
            "components": "組件",
            "equipment": "FPS 物品"
          },
          "noShipChanges": "本次版本沒有艦船變化",
          "noShipChangesText": "本次版本沒有修改任何艦船的數據，也沒有新增艦船。",
          "browseShips": "瀏覽所有艦船",
          "seeEveryChange": "查看所有變化",
          "newShip": "新艦船",
          "moreFields": {
            "one": "以及另外 %{count} 項",
            "other": "以及另外 %{count} 項"
          },
          "appeared": {
            "components": {
              "one": "%{count} 個新組件",
              "other": "%{count} 個新組件"
            },
            "equipment": {
              "one": "%{count} 個新 FPS 物品",
              "other": "%{count} 個新 FPS 物品"
            }
          },
          "vanished": {
            "equipment": {
              "one": "移除 %{count} 個 FPS 物品",
              "other": "移除 %{count} 個 FPS 物品"
            }
          },
          "yes": "是",
          "no": "否",
          "fields": {
            "mass": "質量",
            "hullHealth": "船體耐久",
            "personalInventory": "個人儲物",
            "mainAcceleration": "主推進加速度",
            "retroAcceleration": "反推加速度",
            "scmSpeed": "SCM 速度",
            "scmSpeedBoosted": "SCM 加力速度",
            "reverseSpeedBoosted": "倒退加力速度",
            "maxSpeed": "最高速度",
            "pitch": "俯仰",
            "yaw": "偏航",
            "roll": "滾轉",
            "crew": "船員",
            "weaponPoolSize": "武器池",
            "beds": "床位",
            "lockers": "儲物櫃",
            "rateOfFire": "射速",
            "range": "射程",
            "storage": "容量",
            "damageReduction": "傷害減免",
            "temperatureRating": "溫度範圍",
            "radiationProtection": "輻射防護",
            "radiationScrubRate": "輻射清除速率",
            "name": "名稱",
            "size": "尺寸",
            "grade": "等級",
            "hidden": "隱藏",
            "itemType": "類型",
            "coreCompatibility": "核心相容性"
          },
          "loadingScreen": "Alpha %{version} 的載入畫面",
          "openLoadingScreen": "開啟載入畫面"
        },
        "gameEvents": {
          "title": "宇宙動態",
          "subline": "遊戲中正在進行的活動，由 Fleetyards 團隊精選。"
        },
        "latestShips": {
          "title": "最新艦船",
          "all": "所有艦船"
        },
        "signUpPanel": {
          "kicker": "加入他們",
          "title": "帶上你的機庫",
          "orWith": "或使用",
          "loggedIn": "已經和我們一起飛行？",
          "login": "登入",
          "counts": {
            "vehicles": "艘艦船在 Fleetyards 機庫中",
            "fleets": "個艦隊在這裡組織",
            "ships": "艘艦船在資料庫中"
          },
          "links": {
            "discord": {
              "title": "社群 Discord",
              "text": "問題、想法和開發日誌"
            },
            "support": {
              "title": "支持 Fleetyards",
              "text": "由飛行員營運，由飛行員資助"
            },
            "api": {
              "title": "API 與文件",
              "text": "基於同樣的資料進行開發"
            }
          },
          "kickerSignedIn": "社群",
          "titleSignedIn": "你的機庫在等你"
        },
        "openHangar": "開啟你的機庫"
      },
      "patch": {
        "title": "Alpha %{version}",
        "shipsChanged": "改動的艦船",
        "inYourHangar": "你機庫中的",
        "whatChanged": "查看改動",
        "yoursChanged": {
          "one": "此版本改動了你的 %{count} 艘艦船。",
          "other": "此版本改動了你的 %{count} 艘艦船。"
        }
      },
      "dashboard": {
        "welcome": "歡迎回來，%{name}",
        "welcomeAnonymous": "歡迎回來",
        "invites": {
          "title": "%{fleet} 邀請你加入",
          "text": "接受後即可查看其活動、公告和成員。",
          "accept": "接受",
          "decline": "拒絕",
          "failed": "操作失敗。請在艦隊邀請頁面重試。"
        },
        "comingUp": {
          "title": "即將到來",
          "calendar": "日曆",
          "groups": {
            "today": "今天",
            "week": "本週",
            "later": "之後"
          },
          "inGame": "遊戲內",
          "answer": "報名",
          "signupFailed": "無法儲存你的報名。請開啟活動頁面重試。",
          "empty": {
            "title": "暫無安排",
            "hint": "你的艦隊活動和遊戲活動會顯示在這裡。",
            "action": "尋找艦隊"
          }
        },
        "fleets": {
          "title": "我的艦隊",
          "online": {
            "one": "%{total} 人中 %{count} 人在線",
            "other": "%{total} 人中 %{count} 人在線"
          },
          "members": {
            "one": "%{count} 名成員",
            "other": "%{count} 名成員"
          },
          "requests": "入隊申請",
          "transfers": "轉移",
          "empty": {
            "title": "還沒有艦隊",
            "hint": "加入一個組織來規劃活動和共享庫存。",
            "action": "瀏覽艦隊"
          }
        },
        "changes": {
          "title": "你在 %{version} 中的艦船",
          "titleWithoutVersion": "你在本補丁中的艦船",
          "owned": {
            "one": "在你的機庫中",
            "other": "機庫中有 %{count} 艘"
          },
          "wanted": "在你的願望清單中",
          "changes": "改動",
          "hangar": "機庫",
          "empty": {
            "title": "你的艦船都沒有改動",
            "hint": "當某個版本改動了你機庫或願望清單中的艦船時，它們會顯示在這裡。"
          }
        },
        "hangar": {
          "title": "機庫",
          "open": "開啟",
          "ships": "艦船",
          "wishlist": "願望清單",
          "synced": "已從 RSI 同步",
          "empty": {
            "title": "你的機庫是空的",
            "hint": "手動加入艦船，或從 RSI 同步。",
            "action": "設定機庫"
          }
        },
        "notifications": {
          "title": "通知",
          "empty": "你已全部看完。"
        },
        "friends": {
          "title": "好友",
          "online": "在線",
          "pending": {
            "one": "%{count} 個好友請求",
            "other": "%{count} 個好友請求"
          },
          "empty": {
            "title": "還沒有好友",
            "hint": "加入一起飛行的飛行員，即可看到他們何時在線。"
          }
        }
      }
    }
  }
}
